const defaultCollectSelectedArticles = () => {
  const articles = []
  document
    .querySelectorAll('#deliveryList .cart-group .product-item:not(.d-none)')
    .forEach(item => {
      const checkbox = item.querySelector('.form-check-input')
      const article = item.getAttribute('data-id')
      if (checkbox && checkbox.checked && article && !articles.includes(article)) {
        articles.push(article)
      }
    })
  return articles
}
const createMoveProductsService = ({
  apiMove,
  collectSelectedArticles = defaultCollectSelectedArticles,
  formDataFactory = () => new FormData(),
  notify = message => alert(message),
  reload = () => location.reload(),
}) => {
  const moveProducts = contractorId => {
    if (contractorId === 0) {
      notify('Выберите контрагента')
      return
    }

    const articleList = collectSelectedArticles()
    if (articleList.length === 0) {
      notify('Выберите товары для перемещения')
      return
    }

    const formData = formDataFactory()
    formData.set('contractorId', contractorId)
    articleList.forEach(article => formData.append('articles[]', article))

    return apiMove(formData).then(() => reload())
  }

  return { moveProducts }
}

export { createMoveProductsService }
export default createMoveProductsService
